var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_core.js
// module id = 39
// module chunks = 0